import React from "react";
import { Form, Select, Tooltip } from "antd";

const { Item } = Form;
const { Option } = Select;

const SelectItem = ({
  getFieldDecorator,
  allowClear = true,
  useNameAndCode,
  formItemLayout,
  initialValue,
  placeholder,
  useLongCode,
  wrapperCol,
  showSearch,
  fieldName,
  className,
  onChange,
  onSelect,
  disabled,
  labelCol,
  optional,
  useCode,
  message,
  options,
  toolTip,
  label,
}) => (
  <Item
    colon={false}
    label={label}
    labelCol={labelCol ? { span: labelCol } : formItemLayout.labelCol}
    wrapperCol={wrapperCol ? { span: wrapperCol } : formItemLayout.wrapperCol}
  >
    {getFieldDecorator(fieldName, {
      ...{ initialValue },
      rules: [
        {
          required: message && !optional,
          message,
        },
      ],
    })(
      <Select
        onChange={onChange}
        disabled={disabled}
        onSelect={onSelect}
        className={className}
        allowClear={allowClear}
        showSearch={showSearch}
        placeholder={placeholder}
        filterOption={
          showSearch
            ? (input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            : undefined
        }
      >
        {options &&
          options !== "e" &&
          options.map((o, i) => (
            <Option key={i} value={o.id}>
              {toolTip ? (
                <Tooltip title={o.name}>{o.longCode || o.code}</Tooltip>
              ) : useNameAndCode ? (
                `${o.code} - ${o.name}`
              ) : useLongCode ? (
                o.longCode || o.code
              ) : useCode ? (
                o.code
              ) : (
                o.name
              )}
            </Option>
          ))}
      </Select>
    )}
  </Item>
);

export default SelectItem;
